import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import Avatar from './Avatar';
import AvatarLock from './AvatarLock';

function AvatarAction({ userID, name, source, className, style, color = null, lock, admin, enable }) {
  const socket = useSelector(state => state.socketPM);
  const onClick = () => {
    if (admin && enable) {
      socket.emit(`update user spectator`, { userID })
    }
  }
  return (
    <div style={{ cursor: admin ? 'pointer' : 'default' }} onClick={onClick}>
      { !lock ? <Avatar name={name} source={source} color={color} onClick={onClick} /> : <AvatarLock color={color} onClick={onClick} /> }
    </div>
  )
}

AvatarAction.propTypes = {
  userID: PropTypes.any,
  name: PropTypes.string,
  source: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
  lock: PropTypes.bool,
  enable: PropTypes.bool,
  admin: PropTypes.bool
}

export default AvatarAction;
